module.exports = __webpack_public_path__ + "media/images/iconSocialX__okGreen--dark-ce8424eba46447388a3f5142b521a0dd.png";